import React from 'react';
import PropTypes from 'prop-types';
import { useTrans } from '../../../services/i18n';
import { Paper, SpacingContainer } from '../../../components/common/Containers';
import { Grid } from '@material-ui/core';
import SpacingContainerBase from '../../../components/layouts/SpacingContainerBase';
import Typography from '../../../components/common/Typography';
import StatusChip from './Status'
import UserMenu from '../components/UserMenu'
import FieldValue from '../../../components/generics/Helpers/FieldValue';
import { intlDateFormat, formatPrettyUnixDate } from '../../../utils/dateUtils';
import { DATE_TIME_PRETTY_FORMAT } from '../../../constants'

const SummaryUser = ({ item }) => {
  const { trans } = useTrans();

  return (
    <SpacingContainerBase>
      <Paper component={SpacingContainer} py={4} px="5sm3">
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item xs zeroMinWidth>
            <Typography variant="h1" weight="bold">
              {item.name} { item.familyName }
            </Typography>
          </Grid>
          <Grid item>
            <StatusChip status={item.isVerified ? 'Active' : 'Invited'} />
            <UserMenu user={item} />
          </Grid>
        </Grid>

        <Grid style={{ marginTop: '1rem' }}
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item sm={2} xs={12}>
            <FieldValue value={intlDateFormat(item.createdAt)} label={trans('registered')} />
          </Grid>
          <Grid item sm={3} xs={12}>
            <FieldValue
              value={item.lastLogin ? formatPrettyUnixDate(item.lastLogin, DATE_TIME_PRETTY_FORMAT) : ''}
              label={trans('last-login')}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FieldValue value={item.email} label={trans('email')} />
          </Grid>
        </Grid>
      </Paper>
    </SpacingContainerBase>
  )
}

SummaryUser.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    familyName: PropTypes.string,
    email: PropTypes.string,
    isVerified: PropTypes.number,
    createdAt: PropTypes.string,
    lastLogin: PropTypes.number,
  }).isRequired,
}

export default SummaryUser
